import React from 'react';
import { SvgIcon, SvgIconProps } from "@mui/material";

export const LibraryIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M2.73 2A2.68 2.68 0 0 0 0 4.63v9.75C0 15.88 1.28 17 2.73 17H4v-2H2.73c-.46 0-.73-.34-.73-.63V4.63c0-.3.27-.63.73-.63h15.54c.46 0 .73.34.73.63V6h2V4.62A2.69 2.69 0 0 0 18.27 2H2.73Z" /><path fill-rule="evenodd" clip-rule="evenodd" d="M5.82 6C4.82 6 4 6.78 4 7.75v10.5c0 .97.81 1.75 1.82 1.75h16.36c1 0 1.82-.78 1.82-1.75V7.75C24 6.78 23.19 6 22.18 6H5.82Zm7.68 10.15a1 1 0 0 1-1.5-.87v-4.56a1 1 0 0 1 1.5-.87l3.98 2.28a1 1 0 0 1 0 1.74l-3.98 2.28Z" />
    </SvgIcon>
);
